import { ApiResponse } from '../types';
import { ApiService } from './api';

export interface SessionStats {
  totalQuestions: number;
  totalResponses: number;
  totalCorrectResponses: number;
  totalEvaluatedOpenEnded: number;
  openEndedAverage: number;
  qcmVfAccuracy: number;
  globalAccuracy: number;
  questionsWithCorrectAnswer: number;
  openEndedQuestions: number;
}

export interface SessionStatsResponse {
  success: boolean;
  sessionId: string;
  sessionName: string;
  sessionCode: string;
  stats: SessionStats;
}

export const statsApi = {
  /**
   * Récupère les statistiques d'une session sans doublons
   */
  getSessionStats: async (sessionId: string): Promise<SessionStatsResponse> => {
    const response = await ApiService.request<SessionStatsResponse & { error?: string }>(`/sessions/${sessionId}/stats`);
    if (response.success) {
      return response as SessionStatsResponse;
    }
    throw new Error(response.error || 'Erreur inconnue lors du chargement des statistiques de session');
  },

  /**
   * Récupère les statistiques d'une question sans doublons
   */
  getQuestionStats: async (questionId: string): Promise<any> => {
    const response = await ApiService.request<ApiResponse<any>>(`/questions/${questionId}/stats`);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Erreur inconnue lors du chargement des statistiques de question');
  }
};
